import React from 'react';
import InvitationDTO from '../../model/InvitationDTO';
import RowInvitationReceived from '../row/RowInvitationReceived';
import Translator from '../../translations/Translator';

function TableInvitationReceived(props: { data: Array<InvitationDTO> }) {
    // @ts-ignore
    return (
        <table className="table table-striped table-hover table-dark table-sm table-responsive-sm">
            <thead>
                <tr>
                    <th scope="col-2" className="col-4">
                        <Translator value="i18n.date" />
                    </th>
                    <th scope="col-2" className="col-6">
                        <Translator value="i18n.company" />
                    </th>
                    <th scope="col-1" className="col-1"></th>
                    <th scope="col-1" className="col-1"></th>
                </tr>
            </thead>
            <tbody>
                {props.data.map((item) => (
                    <RowInvitationReceived invitation={item} />
                ))}
            </tbody>
        </table>
    );
}

export default TableInvitationReceived;
